import React from 'react';
import { SkinPageProps } from '../SkinPage';
import Page from '../../Page';
import styles from './styles/ThreeDeePageSkin.scss';

const ThreeDeePageSkin: React.FC<SkinPageProps> = ({
  id,
  pageDidMount,
  onClick,
  onDblClick,
  children,
  onMouseEnter,
  onMouseLeave,
}) => {
  return (
    <div
      id={id}
      className={styles.pageWrapper}
      ref={pageDidMount}
      onClick={onClick}
      onDoubleClick={onDblClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <div className={styles.bg}>
        <div className={styles.innerBg} />
      </div>
      <div className={styles.inlineContent}>{children()}</div>
    </div>
  );
};

const ThreeDeePage: React.FC<SkinPageProps> = props => (
  <Page {...props} skin={ThreeDeePageSkin} />
);

export default ThreeDeePage;
